import script from "./CollectionDetailDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionDetailDrawer.vue?vue&type=script&setup=true&lang=js"

import "./CollectionDetailDrawer.vue?vue&type=style&index=0&id=aae83b56&lang=scss"

const __exports__ = script;

export default __exports__